import React from "react";
import { MaterialReactTable } from "material-react-table";

const bomColumns = [
  {
    accessorKey: "itemNo",
    header: "Item No",
    size: 80,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
  {
    accessorKey: "materialDescription",
    header: "Material Description",
    size: 300,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "left" },
  },
  {
    accessorKey: "qty",
    header: "Qty",
    size: 80,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
  {
    accessorKey: "dimension",
    header: "Dimension",
    size: 150,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
  {
    accessorKey: "unit",
    header: "Unit",
    size: 80,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
  {
    accessorKey: "weightLb",
    header: "Weight (lb)",
    size: 110,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
];

const tableProps = {
  muiTableHeadCellProps: {
    sx: {
      backgroundColor: "hsla(250, 86%, 97%, 1)",
      borderRight: "1px solid rgba(224,224,224,1)",
      borderTop: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        marginBottom: "0.4px",
      },
      fontSize: "0.8rem",
      verticalAlign: "middle",
      height: "40.4px",
    },
  },
  muiTableProps: {
    size: "small",
    sx: {
      "& .MuiInputBase-root": {
        fontSize: "0.8rem",
        borderRadius: 0,
      },
      "& .MuiButtonBase-root": {
        fontSize: "0.8rem",
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      padding: "0.5rem",
      textAlign: "center",
    },
  },
};

export default function BomTable({ data, dimensionWidth = 150 }) {
  const columns = bomColumns.map((col) =>
    col.accessorKey === "dimension"
      ? { ...col, size: dimensionWidth }
      : col,
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data || []}
      enableColumnActions={false}
      enableTopToolbar={false}
      enableBottomToolbar={false}
      initialState={{ pagination: { pageSize: 50 } }}
      {...tableProps}
    />
  );
}
